export default __webpack_public_path__ + "static/media/port-logo.2f7e95bc.jpeg";